<template>
  <q-page :style-fn="getPageStyles">
    <div class="row full-height q-col-gutter-x-xl">
      <div class="col-8 gt-xs"></div>
      <div
        class="col-sm-4 col-xs-12 column justify-xs-center items-sm-end items-xs-center"
      >
        <LoginForm
          class="full-width"
          :style="{
            margin: screen.gt.xs ? 'calc(18vh - 4vw) 0 0 0' : '0 0 126px 0',
            maxWidth: '350px',
          }"
        />

        <div class="full-width" :class="{ 'q-mt-auto': screen.gt.xs }">
          <p
            class="text-xs q-mt-sm q-mb-none"
            :class="[screen.gt.xs ? 'text-right' : 'text-center']"
          >
            ©Poshn, Crafted with <span class="text-error-70">❤️</span> in India
          </p>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
export default {
  name: "LoginPage",
};
</script>

<route>
{
  meta: {
    layout: 'auth'
  }
}
</route>

<script setup>
import { useMeta, useQuasar } from "quasar";

useMeta({ title: "Login" });

const $q = useQuasar();

const { screen } = $q;

const getPageStyles = (offset) => {
  return {
    height: `calc(100dvh - ${offset}px)`,

    padding: screen.gt.xs ? `0 120px 60px 120px` : `16px`,
  };
};
</script>
